import React from 'react';
import { IPropertyWizardInput } from './NewPropertyWizard';
import { IProperty } from '../../utils/JsonApiRequest';
// import styles from './Options.scss';
import styles from './NewPropertyWizard.scss';

export interface IOptionsProps extends IPropertyWizardInput {}

const Options: React.FC<React.PropsWithChildren<IOptionsProps>> = ({ step = null, data = null, onChange = () => {} }) => {
    return (
        <div className={styles.options + ' ' + styles[step.name]}>
            {Object.keys(step?.options).map((key) => {
                const option = step.options[key];
                const Image = step.images ? step.images[key] : null;

                return (
                    <div
                        key={key}
                        className={styles.option + (key === data[step.name] ? ' ' + styles.active : '')}
                        onClick={() => {
                            onChange(step.name, key);
                        }}
                    >
                        {Image}
                        <span>{option}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default Options;
